import React from 'react';

const Dashboard = () => {
    return (
        <div>
            &nbsp;
        </div>
    );
};

export default Dashboard;
